import { SupportTicketCategory } from '../../core/data-models/support-ticket-category.model';
import { SupportTicketPriority } from '../../core/data-models/support-ticket-priority.model';
import { SupportTicketStatus } from '../../core/data-models/support-ticket-status.model';

/**
 * Category options for UI
 */
export const SUPPORT_TICKET_CATEGORIES: { value: SupportTicketCategory; label: string }[] = [
  { value: 'Technical Issue', label: 'Technical Issue' },
  { value: 'Equipment Problem', label: 'Equipment Problem' },
  { value: 'Billing Question', label: 'Billing Question' },
  { value: 'Training Request', label: 'Training Request' },
  { value: 'Account Issue', label: 'Account Issue' },
  { value: 'Feature Request', label: 'Feature Request' },
  { value: 'Other', label: 'Other' }
];

/**
 * Priority display info
 */
export const SUPPORT_TICKET_PRIORITIES: { value: SupportTicketPriority; label: string; color: string }[] = [
  { value: 'low', label: 'Low', color: 'info' },
  { value: 'medium', label: 'Medium', color: 'secondary' },
  { value: 'high', label: 'High', color: 'warning' },
  { value: 'urgent', label: 'Urgent', color: 'danger' }
];

/**
 * Status display info
 */
export const SUPPORT_TICKET_STATUSES: { value: SupportTicketStatus; label: string; color: string }[] = [
  { value: 'open', label: 'Open', color: 'primary' },
  { value: 'in_progress', label: 'In Progress', color: 'warning' },
  { value: 'resolved', label: 'Resolved', color: 'success' },
  { value: 'closed', label: 'Closed', color: 'medium' }
];
